import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/internal/Observable";
import { AuthenticateRequestModel, EnableMfaResponse, MfaStatusResponse, VerifyMfaRequest, VerifyMfaSetupRequest } from "../model/authenticate.model";


@Injectable({
    providedIn: "root",
})
export class AuthenticateApiService {

    constructor(private http: HttpClient) {
    }

    authenticate(authenticateRequestModel: AuthenticateRequestModel): Observable<any> {
        return this.http.post<any>("/Login",authenticateRequestModel);
    }

    verifyMfa(request: VerifyMfaRequest): Observable<any> {
        return this.http.post<any>("/VerifyMfa", request);
    }

    enableMfa(): Observable<EnableMfaResponse> {
        return this.http.post<EnableMfaResponse>("/Mfa/Enable", {});
    }

    verifyMfaSetup(request: VerifyMfaSetupRequest): Observable<any> {
        return this.http.post<any>("/Mfa/Verify", request);
    }

    disableMfa(request: VerifyMfaSetupRequest): Observable<any> {
        return this.http.post<any>("/Mfa/Disable", request);
    }

    getMfaStatus(): Observable<MfaStatusResponse> {
        return this.http.get<MfaStatusResponse>("/Mfa/Status");
    }

    logOut(): Observable<any> {
        return this.http.post<any>("/Logout",'');
    }

    keepAlive(): Observable<any> {
        return this.http.get<any>("/KeepAlive");
    }
}
